import { Toaster as Sonner } from "sonner";

import { useTheme } from "@/lib/theme";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * Global toast surface. Mounted once in AppShell; call `toast(...)` from
 * anywhere (import { toast } from "sonner"). Passes our light/dark `mode` to
 * sonner; the palette is irrelevant here since the toast surfaces are styled
 * with token classes (`!bg-card`, …) that resolve per palette automatically.
 */
export function Toaster(props: ToasterProps) {
  const { mode } = useTheme();

  return (
    <Sonner
      theme={mode}
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast !bg-card !text-foreground !border !border-border !shadow-raised",
          description: "!text-muted-foreground",
          actionButton: "!bg-primary !text-primary-foreground",
          cancelButton: "!bg-surface-elevated !text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}

export { toast } from "sonner";
